import classNames from "classnames";
import { useMetadata } from "PFApp/components/activity_commons/activity_details_more_info";
import { Typography } from "PFComponents/typography";
import { MatchedActivity } from "PFTypes";
import React from "react";

import { Section } from "../../components";
import css from "./custom_fields_section.module.scss";
import { AvailabilitySection } from "./parts/availability_section";

type CustomFieldsSectionProps = {
  role: MatchedActivity["activity"];
};

export const CustomFieldsSection = ({ role }: CustomFieldsSectionProps): JSX.Element => {
  const metadata = useMetadata({ activity: role, metadataToOmit: ["skills"], valuesSeparator: ", " });

  return (
    <div className={css.customFieldsWrapper}>
      {metadata.map(({ name, title, text, type }) => {
        const isFullWidthSection = type === "availability";
        const sectionClassNames = classNames(css.section, { [css.fullWidth]: isFullWidthSection });

        if (type === "availability") {
          return <AvailabilitySection key={name} role={role} className={sectionClassNames} />;
        }

        return (
          <Section key={name} title={title} className={sectionClassNames}>
            <Typography variant="bodyRegular" noMargin>
              {text}
            </Typography>
          </Section>
        );
      })}
    </div>
  );
};
